<template>
  <section class="app-main" :class="{'main-border': mainBorder}">
    <router-view v-slot="{ Component, route }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <component :is="Component" v-if="!route.meta.link" :key="route.path" />
        </keep-alive>
      </transition>
    </router-view>
    <!-- transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition -->
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapState({
      mainBorder: state => state.settings.mainBorder,
      cachedViews: state => state.tagsView.cachedViews
    }),
    key() {
      console.log(this.$route)
      return this.$route.fullPath
    },
    keepAlive() {
      return this.$route.meta.keepAlive
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  flex: 1;
  &.main-border {
    border-top: 1px solid #e6ebf5;
  }
}

.fixed-header .app-main {
  overflow: hidden auto;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
